
import { Link } from 'react-router-dom';

export default function FeedbackPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-sky-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-cyan-600 to-sky-600 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/motivation" className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors">
              <i className="ri-arrow-left-line mr-2"></i>
              動機付け一覧に戻る
            </Link>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-chat-check-line text-4xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">フィードバック理論</h1>
            <p className="text-xl text-white/90">Feedback Theory</p>
          </div>
        </div>
      </section>

      {/* Core Message */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">再現可能な情報が学習を促す。人格評価は成長を止めやすい</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            {/* 良いフィードバックと悪いフィードバック */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-teal-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-contrast-2-line text-xl text-white"></i>
                </div>
                良いフィードバックと悪いフィードバック
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">良いフィードバック</h3>
                  <p className="text-sm text-gray-600 mb-3">再現可能な情報</p>
                  <ul className="text-gray-700 text-sm space-y-2">
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-2 mt-0.5"></i>
                      <span>具体的な行動を指摘</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-2 mt-0.5"></i>
                      <span>改善点が明確</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-2 mt-0.5"></i>
                      <span>次に活かせる</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-6 border border-red-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-close-circle-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">悪いフィードバック</h3>
                  <p className="text-sm text-gray-600 mb-3">人格評価</p>
                  <ul className="text-gray-700 text-sm space-y-2">
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mr-2 mt-0.5"></i>
                      <span>「あなたは〇〇だ」という評価</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mr-2 mt-0.5"></i>
                      <span>抽象的で曖昧</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mr-2 mt-0.5"></i>
                      <span>防衛反応を引き起こす</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 薬局運営への活用 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-teal-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-hospital-line text-xl text-white"></i>
                </div>
                薬局運営への活用
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 border border-teal-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-user-voice-line text-teal-600 mr-2"></i>
                    1on1の質向上
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    1on1ミーティングでのフィードバックの質を高めることで、職員の成長を促進できます。
                  </p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-teal-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-close-circle-line text-red-500 mr-2"></i>
                        避けるべき表現
                      </h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・「もっと頑張って」</li>
                        <li>・「意識が足りない」</li>
                        <li>・「あなたは〇〇な人だ」</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-cyan-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-checkbox-circle-line text-green-500 mr-2"></i>
                        推奨する表現
                      </h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・「〇〇の場面で△△すると良い」</li>
                        <li>・「次は□□を試してみては」</li>
                        <li>・「◇◇の対応は効果的だった」</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-cyan-50 to-sky-50 rounded-xl p-6 border border-cyan-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-medal-line text-cyan-600 mr-2"></i>
                    有能感の回収設計
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    フィードバックを通じて、職員が「自分は成長している」「貢献できている」と感じられる機会を設計します。
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start p-3 bg-white rounded-lg border border-cyan-100">
                      <i className="ri-checkbox-circle-fill text-cyan-500 mr-3 mt-0.5"></i>
                      <span className="text-gray-700 text-sm">成長した点を具体的に伝える</span>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-cyan-100">
                      <i className="ri-checkbox-circle-fill text-cyan-500 mr-3 mt-0.5"></i>
                      <span className="text-gray-700 text-sm">以前との比較で進歩を可視化する</span>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-cyan-100">
                      <i className="ri-checkbox-circle-fill text-cyan-500 mr-3 mt-0.5"></i>
                      <span className="text-gray-700 text-sm">チームへの貢献を認める</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* フィードバックの型 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-teal-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-file-list-3-line text-xl text-white"></i>
                </div>
                フィードバックの型（SBI）
              </h2>
              <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 border border-teal-200">
                <p className="text-gray-700 leading-relaxed mb-4">
                  効果的なフィードバックには「SBI」の型が有効です。
                </p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">S</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Situation（状況）</h4>
                      <p className="text-sm text-gray-600">いつ、どこで、どのような状況だったか</p>
                      <p className="text-sm text-teal-600 mt-1">例：「今日の午前中、〇〇さんの服薬指導の場面で」</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">B</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Behavior（行動）</h4>
                      <p className="text-sm text-gray-600">具体的にどのような行動をしたか</p>
                      <p className="text-sm text-cyan-600 mt-1">例：「副作用について図を使って説明していましたね」</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-sky-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">I</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Impact（影響）</h4>
                      <p className="text-sm text-gray-600">その行動がどのような影響を与えたか</p>
                      <p className="text-sm text-sky-600 mt-1">例：「患者さんがとても安心した表情をされていました」</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 明日の一手 */}
            <div className="bg-gradient-to-br from-teal-600 via-cyan-600 to-sky-600 rounded-2xl shadow-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 flex items-center">
                <i className="ri-calendar-check-line text-3xl mr-3"></i>
                明日の一手
              </h2>
              <p className="text-lg text-white/90 leading-relaxed mb-6">
                次回のフィードバックで「SBI」の型を使ってみましょう。
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6">
                <p className="text-white font-semibold mb-2">具体的なアクション：</p>
                <p className="text-white/90 leading-relaxed">
                  「〇〇の場面で（S）、△△という対応をしていましたね（B）。それによって□□という効果がありました（I）」という形でフィードバックする。
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-8 border-t border-gray-200">
              <Link to="/motivation/reinforcement" className="flex items-center text-teal-600 hover:text-teal-700 font-semibold transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                強化理論
              </Link>
              <Link to="/motivation/nudge" className="flex items-center text-teal-600 hover:text-teal-700 font-semibold transition-colors">
                ナッジ理論
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
